import React from "react";
import SpecialUnit from "./SpecialUnit";

const TrafficBranch = () => <SpecialUnit speId={13} />;

export default TrafficBranch;
